/* GRADAZONE - tarjetas del grid: segunda foto bajo demanda (hover / deslizar) + boton "+".
   Vive en un asset compartido porque lo usan la portada, las paginas de coleccion y los
   recomendados de la ficha de producto. */
(function () {

  /* ================= Segunda foto: hover en PC, deslizar en movil =================
     Antes las tarjetas cambiaban de foto SOLAS cada 3,6 s. Se retiro (9 ago 2026): un
     escaparate en el que las fotos se mueven sin que nadie las toque se lee como un banner,
     no como una ficha, y ademas hacia imposible comparar dos productos de un vistazo.

     Ahora la principal se queda FIJA y la segunda aparece solo si el visitante lo pide:
       · PC: al pasar el cursor por la tarjeta (y vuelve al salir).
       · Movil: deslizando el dedo en horizontal sobre la foto, que ademas permite
         recorrer las tres, no solo la segunda.
     Sin temporizadores ni IntersectionObserver: no hay nada que arrancar ni parar. */

  var UMBRAL = 30;   // px de arrastre para contar como deslizamiento y no como toque

  function prepara(media) {
    var imgs = Array.prototype.slice.call(media.querySelectorAll('.cf-card__img'));
    if (imgs.length < 2) return;

    // descarta los fotogramas cuyo asset no exista, igual que antes
    imgs.forEach(function (img) {
      img.addEventListener('error', function () {
        img.remove();
        var vivas = media.querySelectorAll('.cf-card__img');
        if (vivas.length) vivas[0].classList.add('is-visible');
      });
    });

    var actual = 0;

    function mostrar(i) {
      var vivas = media.querySelectorAll('.cf-card__img');
      if (!vivas.length) return;
      var n = ((i % vivas.length) + vivas.length) % vivas.length;
      for (var k = 0; k < vivas.length; k++) vivas[k].classList.toggle('is-visible', k === n);
      actual = n;
    }

    // --- PC: hover ---
    media.addEventListener('mouseenter', function () { mostrar(1); });
    media.addEventListener('mouseleave', function () { mostrar(0); });

    // --- Movil: deslizar ---
    var x0 = null, y0 = null;
    media.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    media.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      // solo si el gesto es claramente horizontal: si no, es scroll de la pagina
      if (Math.abs(dx) < UMBRAL || Math.abs(dx) < Math.abs(dy)) return;
      mostrar(actual + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  function inicia() {
    document.querySelectorAll('[data-gz-rotar]').forEach(prepara);

    // las tarjetas clonadas por gz-infinito.js aparecen despues: hay que prepararlas tambien
    var nuevas = new MutationObserver(function (muts) {
      muts.forEach(function (mut) {
        Array.prototype.forEach.call(mut.addedNodes, function (nodo) {
          if (nodo.nodeType !== 1) return;
          if (nodo.matches && nodo.matches('[data-gz-rotar]')) prepara(nodo);
          else if (nodo.querySelectorAll) nodo.querySelectorAll('[data-gz-rotar]').forEach(prepara);
        });
      });
    });
    document.querySelectorAll('.cf-grid, .pdp-rec__track').forEach(function (g) {
      nuevas.observe(g, { childList: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicia);
  else inicia();

  /* ================= Boton "+": anade al carrito y lo abre ================= */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gz-add]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.dataset.ocupado) return;
    b.dataset.ocupado = '1'; b.disabled = true; b.textContent = '·';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(b.dataset.gzAdd), quantity: 1 }) })
      .then(function (r) { return r.json(); })
      .then(function () {
        b.textContent = '✓';
        if (typeof window.GZ_openCart === 'function') window.GZ_openCart();
        else document.querySelector('[data-cart-toggle]') && document.querySelector('[data-cart-toggle]').click();
      })
      .catch(function () { b.textContent = '+'; })
      .then(function () {
        setTimeout(function () { b.textContent = '+'; b.disabled = false; delete b.dataset.ocupado; }, 1200);
      });
  });
})();
